// Coffeescript transformed to Javascript via https://awsm-tools.com/code/coffee2js
// See: http://getcontenttools.com/tutorials/adding-new-tools

import ContentTools from 'ContentTools/build/content-tools.min.js';
import { coffeeExtends } from './helpers';

export const initArtistTool = function () {
    (function (_super) {
        coffeeExtends(ArtistTool, _super);
        function ArtistTool() {
            return ArtistTool.__super__.constructor.apply(this, arguments);
        }
        ContentTools.ToolShelf.stow(ArtistTool, 'artist');
        ArtistTool.label = 'Insert Artist';
        ArtistTool.icon = 'artist';
        ArtistTool.tagName = 'art';
        ArtistTool.apply = (element, selection, callback) => {
            const cursor = selection.get()[0] + 1;

            const tip = element.content.substring(0, selection.get()[0]);
            const tail = element.content.substring(selection.get()[1]);
            const artistHtml = `<${ArtistTool.tagName} contenteditable="false">ARTIST NAME</${ArtistTool.tagName}>`;
            // http://getcontenttools.com/api/html-string
            element.content = tip.concat(
                new window.HTMLString.String(' ', true),
                artistHtml,
                new window.HTMLString.String(' ', true),
                tail,
                false
            );
            element.updateInnerHTML();
            element.taint();

            // Restore the selection
            selection.set(cursor + 12, cursor + 12);
            element.selection(selection);
            ContentTools.Tools.LineBreak.dispatchEditorEvent('tool-applied', {
                name: 'CKP_ArtistTool',
                transform: true
            });
            callback(true);
        };
        return ArtistTool;
    })(ContentTools.Tools.LineBreak);
};
